import React, { useState } from "react";
import style from "./SignUp.module.css";
import PageLayout from "../../components/PageLayout/PageLayout";

import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { createNewUser } from "../../slices/user/userSlice";
import FormikField from "../../stuffs/FormikField/FormikField";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";

import { Button } from "@mui/material";
import {
  Button as ButtonModal,
  Modal,
} from "react-bootstrap";

interface FormValues {
  name: string;
  email: string;
  password: string;
  passwordConfirmation: string;
}

const initialValues: FormValues = {
  name: "",
  email: "",
  password: "",
  passwordConfirmation: "",
};

const NewUserSchema = Yup.object().shape({
  name: Yup.string().required("Pole wymagane!"),

  email: Yup.string()
    .email("Wymagany poprawny adres email!")
    .required("Pole wymagane!"),

  password: Yup.string().required(
    "Pole wymagane!"
  ),

  passwordConfirmation: Yup.string()
    .oneOf(
      [Yup.ref("password"), null],
      "Hasło musi pasować!"
    )
    .required("Pole wymagane!"),
});

const SignUp: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [
    showNewUserModal,
    setShowNewUserModal,
  ] = useState(false);

  const handleCloseNewUserModal = () => {
    setShowNewUserModal(false);
    history.push("/");
  };

  const handleSubmit = (
    values: FormValues
  ): void => {
    dispatch(createNewUser(values));
    console.log(values);
    setShowNewUserModal(true);
  };

  return (
    <PageLayout>
      <div className={style.SignUp}>
        <div className={style.SignUpBox}>
          <h1>Zarejestruj nowe konto</h1>

          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={NewUserSchema}
          >
            {({
              isValid,
              dirty,
              errors,
              touched,
            }) => (
              <Form className={style.Form}>
                <div className={style.Field}>
                  <FormikField
                    name="name"
                    label="Name"
                    variant="standard"
                    required
                    err={
                      errors.name &&
                      touched.name
                    }
                  />
                </div>

                <div className={style.Field}>
                  <FormikField
                    name="email"
                    label="Email"
                    variant="standard"
                    required
                    err={
                      errors.email &&
                      touched.email
                    }
                  />
                </div>

                <div className={style.Field}>
                  <FormikField
                    name="password"
                    label="Hasło"
                    variant="standard"
                    type="password"
                    required
                    err={
                      errors.password &&
                      touched.password
                    }
                  />
                </div>

                <div className={style.Field}>
                  <FormikField
                    name="passwordConfirmation"
                    label="Powtórz hasło"
                    variant="standard"
                    type="password"
                    required
                    err={
                      errors.passwordConfirmation &&
                      touched.passwordConfirmation
                    }
                  />
                </div>

                <div className={style.Button}>
                  <Button
                    variant="outlined"
                    disabled={
                      !dirty || !isValid
                    }
                    type="submit"
                  >
                    Zarejestruj
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>

      <Modal
        show={showNewUserModal}
        onHide={handleCloseNewUserModal}
        centered
        className={style.NewUserModal}
      >
        <Modal.Header
          closeButton
          className={style.NewUserModalHeader}
        >
          <Modal.Title
            className={style.NewUserModalTitle}
          >
            Utworzenie nowego konta użytkownika
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          className={style.NewUserModalBody}
        >
          Utworzono nowe konto użytkownika.
          Potwierdź swój adres e-mail poprzez
          aktywację konta, stosując się do
          instrukcji otrzymanej na adres e-mail
          podany podczas rejestracji. Sprawdź
          swoją pocztę elektroniczną. Wiadomość
          mogła trafić do folderu SPAM.
        </Modal.Body>

        <Modal.Footer
          className={style.NewUserModalFooter}
        >
          <ButtonModal
            variant="outline-secondary"
            onClick={handleCloseNewUserModal}
          >
            OK
          </ButtonModal>
        </Modal.Footer>
      </Modal>
    </PageLayout>
  );
};

export default SignUp;